import React, { type FC, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Toast } from 'primereact/toast';
import { Password } from 'primereact/password';
import api from '../services/api';
import LoadingView from '../components/LoadingView';

const ResetPassword: FC = () => {
    const [loading, setLoading] = useState(false);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');

    const toast = useRef<Toast>(null);

    const form = useForm();

    const resetPassword = form.handleSubmit(async () => {
        setLoading(true);
        const { success, error } = await api.setPassword(
            newPassword,
            currentPassword,
        );
        if (success) {
            setCurrentPassword('');
            setNewPassword('');
            toast.current?.show({
                severity: 'success',
                summary: 'Password Reset',
            });
        } else {
            toast.current?.show({
                severity: 'warn',
                summary: 'Password Reset Failed',
                detail: error ?? 'unknown error',
            });
        }

        setLoading(false);
    });

    return (
        <>
            <Toast ref={toast} position="top-right" />
            <div className="text-primary text-3xl pb-4">Reset Password</div>
            {loading && <LoadingView />}
            {!loading && (
                <form
                    className="flex flex-col justify-center items-center"
                    onSubmit={resetPassword}
                >
                    <Password
                        required
                        toggleMask
                        className="mb-4"
                        name="currentPassword"
                        placeholder="Current Password"
                        panelClassName="hidden"
                        value={currentPassword}
                        onChange={(event) => {
                            setCurrentPassword(event.target.value);
                        }}
                    />
                    <Password
                        required
                        toggleMask
                        className="mb-4"
                        name="newPassword"
                        placeholder="New Password"
                        panelClassName="hidden"
                        value={newPassword}
                        minLength={8}
                        maxLength={35}
                        pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$"
                        title="Password must be at least 8 characters and contain one lower case letter, one upper case letter, and one number."
                        onChange={(event) => {
                            setNewPassword(event.target.value);
                        }}
                    />
                    <button type="submit" className="btn btn-primary">
                        Submit
                    </button>
                </form>
            )}
        </>
    );
};

export default ResetPassword;
